import { styled } from '@mui/material/styles';
import { Box, Card, CardContent, Chip, Divider, Typography, type TypographyProps } from '@mui/material';
import { TURN_STYLES } from '@/styles/theme';

/** Max width for summary + tables so lines don’t run forever on ultra-wide monitors */
export const SUMMARY_CONTENT_MAX_WIDTH_PX = 1536;

export const PageRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: SUMMARY_CONTENT_MAX_WIDTH_PX,
  margin: '0',
  padding: theme.spacing(3),
  boxSizing: 'border-box',
}));

export const SectionCard = styled(Card)(({ theme }) => ({
  width: '100%',
  minWidth: 0,
  borderRadius: 16,

  ...(theme.palette.mode === 'light' && {
    border: '1px solid rgb(240, 242, 245) !important',
    boxShadow: '0px 2px 10px rgba(0,0,0,0.06)',
  }),

  ...(theme.palette.mode === 'dark' && {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
  }),
}));

export const SectionCardContent = styled(CardContent)(() => ({
  paddingBottom: '16px !important',
}));

export const SectionTitleWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const DividerStyled = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(2, 0),
  borderColor: theme.palette.divider,
}));

export const FlagChip = styled(Chip)(({ theme }) => ({
  color: theme.palette.turn_violet.main,
  borderColor: theme.palette.turn_violet.main,
  bgcolor: 'transparent',
}));

export const TablesWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(3),
  padding: theme.spacing(0, 3, 0, 3),
  width: '100%',
  maxWidth: SUMMARY_CONTENT_MAX_WIDTH_PX,
  boxSizing: 'border-box',
}));
